/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Додаткова інформація",
  "CookieMessage.old.text":
    "Для належної роботи інтернет-магазину ми використовуємо файли cookie. Перегляньте нашу політику використання файлів cookie.",
  "CookieMessage.link": "Згода на використання файлів cookie",
  "CookieMessage.more_information":
    "Прочитати докладніше про використання файлів cookie компанією Kramp",
  "CookieMessage.return": "Повернутися",
  "CookieMessage.intro.body":
    "Ці файли cookie розміщені компанією Kramp і третіми сторонами. Певна річ, що ми турбуємося про вашу конфіденційність. Натискаючи кнопку «Прийняти файли cookie» нижче, ви погоджуєтеся на використання цих файлів cookie. Прийманням цих файлів cookie ви забезпечуєте належну роботу нашого сайту. Приклади їх використання",
  "CookieMessage.intro.list.1": "Автоматичний вхід у ваш обліковий запис",
  "CookieMessage.intro.list.2":
    "Аналіз поведінки відвідувачів із метою покращення сайту",
  "CookieMessage.intro.list.3":
    "Створення профілів клієнта для персоналізації інформації та рекламних оголошень",
  "CookieMessage.intro.extra":
    'Якщо ви не хочете приймати всі файли cookie, можете змінити це у своїх <a>налаштуваннях</a>. Докладніше читайте в нашій <a href="{legalLink}">заяві про конфіденційність і використання файлів cookie</a>.',
  "CookieMessage.intro.title": "Компанія Kramp використовує файли cookie",
  "CookieMessage.settings.body":
    "Ви можете вибирати серед трьох налаштувань файлів cookie. Вибір стандартних налаштувань дасть нам змогу забезпечувати для вас найкращу роботу сайту.",
  "CookieMessage.settings.standard.title": "Стандартні (найпопулярніше)",
  "CookieMessage.settings.standard.body":
    "Файли cookie, що використовуються для авторизації, аналізу замовлень, персоналізації інформації та соціальних мереж, а також файли cookie третіх сторін.",
  "CookieMessage.settings.restricted.title": "Обмежені",
  "CookieMessage.settings.restricted.body":
    "Файли cookie, що використовуються для авторизації, аналізу замовлень і персоналізації інформації.",
  "CookieMessage.settings.highly_restricted.title": "Максимально обмежені",
  "CookieMessage.settings.highly_restricted.body":
    "Ви дозволяєте використання мінімальної кількості файлів cookie. Використовуються виключно для авторизації, здійснення замовлень і забезпечення прийнятної роботи сайту.",
  "CookieMessage.settings.options.title": "Ось що ми робимо",
  "CookieMessage.settings.option.1":
    "Використовуємо файли cookie для забезпечення належної роботи сайту",
  "CookieMessage.settings.option.2": "Досліджуємо поведінку користувачів",
  "CookieMessage.settings.option.3": "Відстежуємо персональну статистику",
  "CookieMessage.settings.option.4":
    "Показуємо інформацію, яка може бути цікавою",
  "CookieMessage.settings.option.5":
    "Використовуємо інформацію для наших рекламних оголошень",
  "CookieMessage.settings.option.6": "Відстежуємо анонімну статистику",
  "CookieMessage.settings.option.7": "Ділимося вашою персональною інформацією",
  "CookieMessage.settings.title": "Налаштування файлів cookie",
  "CookiePage.url": "pravyla-ta-umovy",
};
